module.exports = __webpack_public_path__ + "fonts/FrankRuhlLibre-Regular.af472d9.ttf";